import InputCurrency from './Currency';
import InputDocument from './Document';
import InputPercent from './Percent';

const InputMask = {};

InputMask.Currency = InputCurrency;
InputMask.Document = InputDocument;
InputMask.Percent = InputPercent;

export default InputMask;
